import { services } from '../services';
var action = "itemtransactiondetail";

export const itemtransactiondetailService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    getListByTransaction
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function getListByTransaction(id) {
    return services.restApi(`${action}/itemtransaction/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}